
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { useCourses } from '../../assets/api/UseStudentGetApi';
import ShareCoursesCard from '../../shared/components/parentcounsellor/ShareCoursesCard';
import { GridChildren } from '../../shared/utils/LingtBlueContainer';
import { Box, Grid2, Typography } from '@mui/material';
import { Grid_Gap } from '../../shared/constants';
import { useEffect } from 'react';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import { useProcessedCourses } from '../../shared/hook/useProcessedCourses';

const ShareCourse = () => {
    // const { data, fetchNextPage, hasNextPage, isLoading } = useCourses();
    // useEffect(() => {
    //     if (hasNextPage) {
    //         fetchNextPage();
    //     }
    // }, [hasNextPage, fetchNextPage]);

    // const courses = data?.pages.flatMap(page => page.data) || [];

     const {   pages: courses, isLoading} = useProcessedCourses()
     
   
     return (
        <>

            <NormalContainerWithHeader headerText={"Share Courses"}>

                <Grid2 container spacing={Grid_Gap}>
                    {isLoading ? (
                        [...Array(9)].map((_, index) => (
                            <GridChildren index={index} key={index}>
                                <SkeletonCom />
                            </GridChildren>
                        ))
                    ) : courses?.length === 0 ? (
                        <Box textAlign="center" width="100%">
                            <Typography variant="h6">Course not found.</Typography>
                        </Box>
                    ) : (
                        courses.map((item, index) => (
                            <GridChildren index={index} key={index}>
                                <ShareCoursesCard item={item} />
                            </GridChildren>
                        ))
                    )}
                </Grid2>
            </NormalContainerWithHeader>

        </>
    )
}

export default ShareCourse